import { render } from "./Declined.vue?vue&type=template&id=16cce1ce&scoped=true"
import script from "./Declined.vue?vue&type=script&lang=js"
export * from "./Declined.vue?vue&type=script&lang=js"

import "./Declined.vue?vue&type=style&index=0&id=16cce1ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16cce1ce"]])

export default __exports__